import { useState } from "react";
import { INIT_FILTER_FIELDS } from "../constants";

const useFilters = ({
    isLibrarian
}) => {
    //#region States
    const [filters, setFilters] = useState({ ...INIT_FILTER_FIELDS });
    //#endregion
    //#region Functions
    const changeFilter = (key, value) => {
        setFilters(prev => ({
            ...prev,
            [key]: value
        }));
    }
    const clearFilters = () => {
        let clearedFilters = {};
        if (isLibrarian) {
            const { campusId, ...restClearedFilters } = INIT_FILTER_FIELDS;
            clearedFilters = {
                ...filters,
                ...restClearedFilters
            };
        }
        else clearedFilters = { ...INIT_FILTER_FIELDS }
        setFilters({ ...clearedFilters });
    }
    const filtersAreCompleted = () => {
        return Boolean(
            filters.campusId && 
            filters.libraryId && 
            filters.resourceTypeId && 
            filters.date > -1);
    }
    const checkClearedFilterFields = () => {
        const clearedFilterFields = Object.keys(filters).every(key => {
            if (isLibrarian && key === "campusId")
                return true;
            return filters[key] === INIT_FILTER_FIELDS[key];
        });
        return clearedFilterFields;
    }
    //#endregion
    return {
        filters: {
            value: filters,
            change: changeFilter,
            clear: clearFilters,
            areCompleted: filtersAreCompleted,
            isCleared: checkClearedFilterFields
        }
    };
}

export default useFilters;